
<b-row class="align-items-center">
  <LanguagePopover
    v-if="setting('ui_menu_language')"
    class="position-absolute"
    style="right: 15px; top: 15px"
  />

  <b-col md="6" offset-xl="2" order-md="2" class="col-12 mb-5 mb-md-0">
    <div class="text-center">
      <img
        :src="
          setting(
            'ui_login_image',
            '@/Assets/images/illustrations/happiness.svg'
          )
        "
        class="img-fluid"
      />
    </div>
  </b-col>

  <b-col md="5" xl="4" order-md="1" class="my-5">
    <template v-if="!tokenNeeded">
      <h1 class="display-4 text-center mb-3">
        {{ __('login.title') }}
      </h1>

      <p class="text-muted text-center mb-5">
        {{ __('login.subtitle', { name: systemName }) }}
      </p>

      <form @submit.prevent="login">
        <TextField
          v-model="email"
          name="email"
          type="email"
          :label="__('login.email-label')"
          :placeholder="__('login.email-placeholder')"
        />

        <TextField
          v-model="password"
          type="password"
          name="password"
          :label="__('login.password-label')"
        >
          <template slot="labelRight">
            <RouterLink
              :to="{ name: 'auth.password-recovery' }"
              class="form-text small text-muted"
              tabindex="-1"
            >
              {{ __('login.forgot-password-link') }}
            </RouterLink>
          </template>
        </TextField>

        <b-button
          block
          variant="primary"
          label=""
          class="btn-lg mb-3"
          type="submit"
        >
          {{ __('login.sign-in-button') }}
        </b-button>
      </form>
    </template>

    <template v-else>
      <h1 class="display-4 text-center mb-3">
        {{ __('login.verify') }}
      </h1>

      <p class="text-muted text-center mb-5">
        {{ __('login.tfa') }}
      </p>

      <form @submit.prevent="loginWithTfa">
        <TextField
          v-model="token"
          name="token"
          type="text"
          :label="__('login.confirmation-code')"
          :placeholder="__('password.token-placeholder')"
        />

        <b-button
          block
          variant="primary"
          label=""
          class="btn-lg mb-3"
          type="submit"
        >
          {{ __('buttons.confirm') }}
        </b-button>
      </form>
    </template>
  </b-col>
</b-row>
